import { Box, Burger, Button, Flex, rem, Skeleton } from "@mantine/core"
import { useDisclosure, useHeadroom, useMediaQuery } from "@mantine/hooks"
import useCustomRouter from "hooks/useCustomRouter"
import dynamic from "next/dynamic"
import Image from "next/image"
import Link from "next/link"
import { useRouter } from "next/router"
import { FC, useEffect } from "react"
import { IHeader } from "rules/interface/config/config.interface"
import styles from "./index.module.scss"
const Menu = dynamic(() => import("./components/menu"), { ssr: false, loading: () => <Skeleton w="100%" h={60} animate /> })






const Header: FC<IHeader> = ({ onlyLogo, backBtn, withBanner, hideMenu, unlinkLogo }) => {
    const mobileMatches = useMediaQuery('(max-width: 768px)')

    const pinned = useHeadroom({ fixedAt: 120 });

    const [openedBurgerMenu, { close: closeBurgerMenu, toggle: toggleBurgerMenu }] = useDisclosure(false)

    const router = useRouter()
    const { push } = useCustomRouter()

    useEffect(() => {
        if (openedBurgerMenu) {
            document.body.style.overflow = "hidden"
        }

        return () => {
            document.body.style.overflow = "unset"
        }
    }, [openedBurgerMenu])

    const handleBackBtn = () => {
        try {
            if (router.query?.return) {
                const filters = '{"canBeSelectByCustomer":"true", "sortBaseOn": "totalCommentsStar"}'
                return push(`${router.query.return}?filters=${filters}`, { preserveQuery: ["utm_source", "utm_campaign"] })
            }
            else if ((window as any).navigation?.canGoBack)
                return router.back()
            else
                return push(localStorage.getItem("prevPath") ?? "/contractors", { preserveQuery: ["utm_source", "utm_campaign"] })
        } catch {
            return push("/contractors", { preserveQuery: ["utm_source", "utm_campaign"] })
        }
    }



    return (
        <Flex
            component="header"
            pos="sticky"
            top={{ base: pinned ? 0 : rem(-150), sm: pinned ? 0 : rem(-280) }}
            right={0}
            left={0}
            className={styles.header + " IRANSans"}
            w="100%"
            style={{
                transition: 'top 400ms ease',
                zIndex: 201
            }}
            direction="column"
        >
            <Box w="100%">
                <Flex
                    direction="column"
                    py={{ base: rem(12), sm: "24px 8px" }}
                    h="100%"
                >
                    <Flex
                        w="100%"
                        className="container"
                        align="center"
                        wrap="wrap"
                        justify={{ base: "center", sm: "space-between" }}
                        gap={rem(20)}
                        pb={{ base: "0", sm: rem(16) }}
                        h="100%"
                    >
                        <Flex align="center" flex={1}>
                            {backBtn ?
                                <button
                                    onClick={() => handleBackBtn()}
                                    className="btn transparent mobile_only lh-0"
                                >
                                    <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M18.0375 7.41248L25.625 15L18.0375 22.5875" stroke="black" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M4.375 15H25.4125" stroke="black" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </button> :
                                <Flex align="center" justify="space-between" w="100%" gap={{ base: rem(12), sm: rem(16) }}>
                                    {
                                        (mobileMatches && !hideMenu) &&
                                        <Flex pos="absolute" right={rem(12)}>
                                            <Burger
                                                opened={openedBurgerMenu}
                                                onClick={toggleBurgerMenu}
                                                pos={openedBurgerMenu ? "fixed" : "relative"}
                                                top={openedBurgerMenu ? "10px" : "0"}
                                                left={openedBurgerMenu ? "10px" : "0"}
                                                bg={openedBurgerMenu ? "white" : "transparent"}
                                                style={{ zIndex: 12, borderRadius: 8, transition: "400ms all" }}
                                            />
                                        </Flex>
                                    }

                                    <Flex align="center" w="100%" mih={{ sm: 36 }} px={{ base: rem(38), sm: "0" }} justify={{ base: "center", xs: "start" }} gap={{ base: rem(12), sm: rem(16) }}>
                                        <Link href={unlinkLogo ? location.pathname + location.search : "/"} className="lh-0">
                                            <Image
                                                src={"/images/logos/logo-pictogram.svg"}
                                                alt="logo"
                                                width={mobileMatches ? 20 : 26}
                                                height={mobileMatches ? 20 : 26}
                                            />
                                        </Link>

                                        <Link href={unlinkLogo ? location.pathname + location.search : "/"} className="lh-0">
                                            <Image
                                                src={"/images/logos/logo-dark.png"}
                                                alt="logo"
                                                width={mobileMatches ? 149 : 189}
                                                height={mobileMatches ? 20 : 26}
                                            />
                                        </Link>
                                    </Flex>
                                </Flex>
                            }
                        </Flex>

                        {
                            !onlyLogo &&
                            <Flex visibleFrom="xs">
                                <Link href="/landings/installment">
                                    <Button
                                        bg="orange"
                                        radius="md"
                                        fz={{ base: rem(16), sm: rem(18) }}
                                        lh={rem(16)}
                                        px={rem(16)}
                                        py={0}
                                        h={{ base: 28, sm: 34 }}
                                    >
                                        کابینت اقساطی
                                    </Button>
                                </Link>
                            </Flex>
                        }
                    </Flex>

                    <div
                        className={styles.overlab__header + ` ${openedBurgerMenu ? styles.active : ""}`}
                        onClick={closeBurgerMenu}
                    />

                    {
                        !hideMenu &&

                        <Flex
                            pos={mobileMatches ? "fixed" : "relative"}
                            style={{ zIndex: 10, transition: "400ms all" }}
                            top={{ base: "0", sm: "initial" }}
                            bottom={{ base: "0", sm: "initial" }}
                            right={{ base: openedBurgerMenu ? "0" : "-200%", sm: "initial" }}
                            bg={mobileMatches ? "white" : "transparent"}
                            miw={{ base: "80%", sm: "100%" }}
                            className={styles.navlinks__header}
                            direction="column"
                            align="center"
                            justify="space-between"
                            // py={16}
                        >
                            <Flex
                                className="container"
                                align={{ base: "right", sm: "center" }}
                                direction={{ base: "column", sm: "row" }}
                                gap={{ base: "0", sm: rem(52) }}
                                w={{ base: "100%", sm: "100%" }}
                                h={{ base: "100%", sm: "auto" }}
                            >
                                <Menu />
                            </Flex>

                            <Flex hiddenFrom="xs">
                                <Link href="/landings/installment">
                                    <Button
                                        bg="orange"
                                        radius="md"
                                        fz={{ base: rem(16), sm: rem(18) }}
                                        lh={rem(16)}
                                        px={rem(16)}
                                    >
                                        کابینت اقساطی
                                    </Button>
                                </Link>
                            </Flex>
                        </Flex>
                    }
                </Flex>
            </Box>
        </Flex>
    )
}

export default Header